export default __webpack_public_path__ + "static/media/line_lungs.c294753d.png";